// extracted by mini-css-extract-plugin
export default {"loading":"LoadImg_loading__ZGhU6","text":"LoadImg_text__CbjtG"};